module.exports = __webpack_public_path__ + "img/3D.9c9aa447.png";